export const shiftSearchActionBase = 'shiftSearch';
